import { render } from "./MyEntranceBookings.vue?vue&type=template&id=4b963e46"
import script from "./MyEntranceBookings.vue?vue&type=script&lang=js"
export * from "./MyEntranceBookings.vue?vue&type=script&lang=js"

import "./MyEntranceBookings.vue?vue&type=style&index=0&id=4b963e46&lang=less"
script.render = render

export default script